import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommunityRequestTypesProvider as Provider } from '../../components/context/community-request-types-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const COMMUNITY_REQUEST_TYPES_QUERY = graphql`
query NodeAllCommunityRequestTypesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "CommunityRequestTypes" } }) {
    nodes {
      data
    }
  }
}
`;

export const CommunityRequestTypesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(COMMUNITY_REQUEST_TYPES_QUERY), 'items')}>{children}</Provider>;
};
